var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.historicoSelic,"items-per-page":15,"sort-by":['ano', 'mes'],"sort-desc":['true', 'true'],"footer-props":{
    itemsPerPageAllText: 'Todos',
    itemsPerPageText: 'Itens por página'
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }